export var toArray = function (value) { return Array.isArray(value) ? value : [value]; };
//# sourceMappingURL=toArray.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ultimate/ngxerrors/src/utils/toArray.js
// module id = 662
// module chunks = 323